import { render, staticRenderFns } from "./productionDeliveryInfo.vue?vue&type=template&id=b68757b6&scoped=true"
import script from "./productionDeliveryInfo.vue?vue&type=script&lang=js"
export * from "./productionDeliveryInfo.vue?vue&type=script&lang=js"
import style0 from "./productionDeliveryInfo.vue?vue&type=style&index=0&id=b68757b6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b68757b6",
  null
  
)

export default component.exports